export default class Utils {
  static formatPhoneNumber(phoneNumber) {
    // for now we just remove spaces
    return phoneNumber.replace(/ /g, '')
  }

  static websiteDisplay(websiteAddress) {
    // strips http(s):// from website address for display purposes
    var websiteDisplay = ''
    if (websiteAddress) {
      websiteDisplay = websiteAddress.replace('http://', '')
      websiteDisplay = websiteDisplay.replace('https://', '')
    }
    return websiteDisplay
  }
}



// WEBPACK FOOTER //
// ./src/Utils.js